import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { PROJECTS } from '@/data/site';
import { ArrowUpRight } from 'lucide-react';

const EASE = [0.16, 1, 0.3, 1];

const layout = [
  'md:col-span-8 aspect-[16/10]',
  'md:col-span-4 aspect-[3/4]',
  'md:col-span-4 aspect-[3/4]',
  'md:col-span-8 aspect-[16/10]',
  'md:col-span-6 aspect-[4/3]',
  'md:col-span-6 aspect-[4/3]',
];

export default function ProjectsBento({ compact = false }) {
  const items = compact ? PROJECTS.slice(0, 4) : PROJECTS;
  return (
    <section className="relative bg-[#FAFAF5] py-28 md:py-40">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14 md:mb-20">
          <div>
            <div className="font-mono-label text-[10px] tracking-[0.28em] uppercase text-[#1D4ED8] flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-[#1D4ED8]" /> Selected work
            </div>
            <h2 className="font-display uppercase text-[#0A0A0A] text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
              Rooms we're<br />quietly proud of.
            </h2>
          </div>
          {compact && (
            <Link to="/projects" className="inline-flex items-center gap-3 border border-black/15 text-[#0A0A0A] px-6 py-3 font-mono-label text-[11px] tracking-[0.24em] uppercase hover:bg-black/5 transition-colors">
              Full gallery →
            </Link>
          )}
        </div>

        <div className="grid md:grid-cols-12 gap-4 md:gap-6">
          {items.map((p, i) => (
            <motion.figure
              key={p.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.9, ease: EASE, delay: (i % 3) * 0.08 }}
              className={`relative overflow-hidden group clip-frame ${layout[i % layout.length]}`}
            >
              <img
                src={p.image}
                alt={p.title}
                className="w-full h-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
              <figcaption className="absolute inset-0 p-6 md:p-8 flex flex-col justify-between text-white">
                <div className="flex items-center justify-between">
                  <span className="font-mono-label text-[10px] tracking-[0.24em] uppercase text-white backdrop-blur-md bg-black/40 px-2.5 py-1">
                    {p.category}
                  </span>
                  <span className="font-mono-label text-[10px] tracking-[0.24em] text-white/80">{p.year}</span>
                </div>
                <div className="flex items-end justify-between">
                  <h3 className="font-display uppercase text-2xl md:text-3xl tracking-tight max-w-[70%]">{p.title}</h3>
                  <ArrowUpRight className="w-6 h-6 text-white group-hover:text-[#DC2626] group-hover:-translate-y-1 group-hover:translate-x-1 transition-transform" />
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
